module.exports = __webpack_public_path__ + "static/media/intro_background.535ab836.png";